exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/** Enable this CSS when using the global warning again */\n/*.maintenance-warning {*/\n    /*height: 30px;*/\n    /*width: 100%;*/\n    /*top: 0;*/\n    /*left: 0;*/\n    /*position: fixed;*/\n    /*text-align: center;*/\n    /*background-color: tomato;*/\n    /*display: flex;*/\n    /*justify-content: center;*/\n    /*align-items: center;*/\n/*}*/\n/*.maintenance-warning {*/\n    /*color: #fff;*/\n/*}*/\n\n/*!***/\n /** Override global styles to make place for warning*/\n /**!*/\n/*#app {*/\n    /*position: relative;*/\n    /*top: 30px;*/\n/*}*/\n/*header.header.fixed-top {*/\n    /*top: 30px;*/\n/*}*/\n", ""]);

// exports
